import './sass/all.scss';
import $ from "jquery";
window.$ = window.jQuery = $;
// import barba from "@barba/core";
// import "bootstrap";

// import Scrollbar from "smooth-scrollbar";
import "slick-carousel";

// import svgPanZoom from "svg-pan-zoom";
// import Hammer from "hammerjs";

import { gsap, TimelineMax, Linear, Power2, Power4, Expo } from "gsap";

import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// function unwrap(wrapper) {
//   var docFrag = document.createDocumentFragment();
//   while (wrapper.firstChild) {
//     var child = wrapper.removeChild(wrapper.firstChild);
//     docFrag.appendChild(child);
//   }
//   wrapper.parentNode.replaceChild(docFrag, wrapper);
// }


const contentAnimeteIn = () => {

  function animateFrom(elem) {
    elem.classList.add('enter');
    // elem.classList.remove('leaving');
  }
  function animateLeave(elem) {
    elem.classList.add('leaving');
    elem.classList.remove('enter');
  }
  function hide(elem) {
    elem.classList.remove('enter');
  }

  gsap.utils.toArray(".scrollFadeIn").forEach(function(elem) {      
    ScrollTrigger.create({
      trigger: elem,
      onEnter: function() { animateFrom(elem) }, 
      onEnterBack: function() { animateFrom(elem) },
      // onLeave: function() { animateLeave(elem) }
      // onLeave: function() { hide(elem) }
    })
  })

  gsap.utils.toArray(".scrollHorFadeIn").forEach(function(elem) {      
    ScrollTrigger.create({
      trigger: elem,
      start: () => '+=' + elem.getBoundingClientRect().x * 0.5,
      onEnter: function() { animateFrom(elem) }, 
      onEnterBack: function() { animateFrom(elem) },
      // markers: true,
      // onLeave: function() { animateLeave(elem) }
      // onLeave: function() { hide(elem) }
    })
  })
  
}

const twInnerHeight = () => {
  var hScreen = document.querySelectorAll(".h-screen");
  
  if (hScreen != null) {
    hScreen.forEach((item)=>{
      item.style.height = window.innerHeight + "px";
    });
  }
}


const navSwitch = () => {
  const nav = document.querySelector('.nav');
  const navBtn = nav.querySelector('.navBtn');
  const navMenu = nav.querySelector('.navMenu');
  navBtn.addEventListener('click', () => {
    nav.classList.toggle('active');
    navMenu.classList.toggle('active');
  });
}

const videoEmbed = () => {
  if ( document.querySelector('.videoEmbed') != null ){
    const videos = document.querySelectorAll('.videoEmbed iframe');
    videos.forEach((ele)=>{
      ele.style.height = ele.offsetWidth * 0.5625 + 'px';
    });
  }
}

document.addEventListener("DOMContentLoaded", function() {
  
  // loaded();
  contentAnimeteIn();

  twInnerHeight();
  videoEmbed();

  navSwitch();


  if ( document.querySelector('.girlWrap') != null ){

    const videoCover = document.querySelector('.videoCover');
    const closeBtn = videoCover.querySelector('.closeBtn');

    const videoEmbedInner = document.querySelector('.videoEmbed iframe');
    const questionList = document.querySelector('.questionList');
    const listItem = questionList.querySelectorAll('.listItem');

    const coverName = videoCover.querySelector('.name');
    const coverArticleNormal = videoCover.querySelector('.articleNormal');
    const coverThumbnail = videoCover.querySelector('.thumbnail');
    const coverQuestionListItem_0 = questionList.querySelectorAll('.listItem')[0];
    const coverQuestionListItem_1 = questionList.querySelectorAll('.listItem')[1];
    const coverQuestionListItem_2 = questionList.querySelectorAll('.listItem')[2];
    const coverQuestionListItemQuestion_1 = coverQuestionListItem_0.querySelector('.question_1');
    const coverQuestionListItemQuestion_2 = coverQuestionListItem_1.querySelector('.question_2');
    const coverQuestionListItemQuestion_3 = coverQuestionListItem_2.querySelector('.question_3');
    const coverQuestionListItemAnswer_1 = coverQuestionListItem_0.querySelector('.answer_1 .text');
    const coverQuestionListItemAnswer_2 = coverQuestionListItem_1.querySelector('.answer_2 .text');
    const coverQuestionListItemAnswer_3 = coverQuestionListItem_2.querySelector('.answer_3 .text');


    closeBtn.addEventListener('click', (item)=>{
      videoCover.classList.remove('active');
      videoEmbedInner.src = '';
    });

    listItem.forEach((item)=>{
      item.addEventListener('click', ()=>{
        videoEmbedInner.src = item.dataset.video + '?autoplay=1';
        listItem.forEach((item_)=>{ 
          item_.classList.remove('active'); 
          item_.querySelector('.itemAnswer').style.height = '0px';
        });
        item.classList.toggle('active');

        var itemAnswer = item.querySelector('.itemAnswer');
        var itemAnswerText = item.querySelector('.itemAnswer .text');
        itemAnswer.style.height = itemAnswerText.getBoundingClientRect().height + 'px';

      })
    });
    
    const girlWrap = document.querySelector('.girlWrap');
    const girlItem = girlWrap.querySelectorAll('.girlItem');
  
    girlItem.forEach((item, index)=>{

      item.addEventListener('mouseenter', (ele)=>{
        girlItem.forEach((item_)=>{ item_.classList.add('noActive'); });
        item.classList.add('active');
        item.classList.remove('noActive');
      });

      item.addEventListener('mouseleave', (ele)=>{
        girlItem.forEach((item_)=>{ item_.classList.remove('noActive'); });
        item.classList.remove('active');
      });

      item.addEventListener('click', (ele)=>{
        videoCover.classList.add('active');
        videoEmbedInner.src = girl_story_data[index].video_1 + '?autoplay=1';
        listItem.forEach((item_)=>{ item_.classList.remove('active'); });
        listItem[0].classList.toggle('active');


        setTimeout(function(){
          var itemAnswer = listItem[0].querySelector('.itemAnswer');
          var itemAnswerText = listItem[0].querySelector('.itemAnswer .text');
          itemAnswer.style.height = itemAnswerText.getBoundingClientRect().height + 'px';
          console.log(itemAnswerText.getBoundingClientRect().height)
        }, 200)


        // console.log(girl_story_data[index].name);
        var currentName = girl_story_data[index].name;
        var currentIntro = girl_story_data[index].intro;
        var currentThumbnail = girl_story_data[index].thumbnail;
        var currentVideo_1 = girl_story_data[index].video_1;
        var currentVideo_2 = girl_story_data[index].video_2;
        var currentVideo_3 = girl_story_data[index].video_3;
        var currentAnswer_1 = girl_story_data[index].answer_1;
        var currentAnswer_2 = girl_story_data[index].answer_2;
        var currentAnswer_3 = girl_story_data[index].answer_3;
        var currentQuestion_1 = girl_story_data[index].question_1;
        var currentQuestion_2 = girl_story_data[index].question_2;
        var currentQuestion_3 = girl_story_data[index].question_3;
        
        coverName.textContent = currentName;
        coverArticleNormal.innerHTML = currentIntro;
        coverThumbnail.style.backgroundImage = `url('${currentThumbnail}')`;
        coverQuestionListItem_0.dataset.video = currentVideo_1;
        coverQuestionListItem_1.dataset.video = currentVideo_2;
        coverQuestionListItem_2.dataset.video = currentVideo_3;
        coverQuestionListItemQuestion_1.textContent = currentQuestion_1;
        coverQuestionListItemQuestion_2.textContent = currentQuestion_2;
        coverQuestionListItemQuestion_3.textContent = currentQuestion_3;
        coverQuestionListItemAnswer_1.textContent = currentAnswer_1;
        coverQuestionListItemAnswer_2.textContent = currentAnswer_2;
        coverQuestionListItemAnswer_3.textContent = currentAnswer_3;
      });

    });
  }


  if ( document.querySelector('.exhibitWrap') != null ){

    const exhibitCover = document.querySelector('.exhibitCover');
    const closeBtn = exhibitCover.querySelector('.closeBtn');

    const exhibitSlide = exhibitCover.querySelector('.exhibitSlide');
    const articleNormal = exhibitCover.querySelector('.articleNormal');

    closeBtn.addEventListener('click', (item)=>{
      exhibitCover.classList.remove('active');
      setTimeout(()=>{
        $('.exhibitSlide').slick('unslick');
        exhibitCover.querySelectorAll('.exhibitSlide .photo').forEach((ele)=>{
          ele.remove();
        });
      }, 1000);
    });

    
    const exhibitWrap = document.querySelector('.exhibitWrap');
    const exhibitItem = exhibitWrap.querySelectorAll('.exhibitItem');
  
    exhibitItem.forEach((item, index)=>{

      item.addEventListener('mouseenter', (ele)=>{
        exhibitItem.forEach((item_)=>{ item_.classList.add('noActive'); });
        item.classList.add('active');
        item.classList.remove('noActive');
      });

      item.addEventListener('mouseleave', (ele)=>{
        exhibitItem.forEach((item_)=>{ item_.classList.remove('noActive'); });
        item.classList.remove('active');
      });

      item.addEventListener('click', (ele)=>{

        setTimeout(function(){
          exhibitCover.classList.add('active');
        }, 300);
        
        var currentArticle = exhibit_data[index].article;
        var currentPhotos = exhibit_data[index].photos;
        
        articleNormal.innerHTML = currentArticle;
        currentPhotos.forEach((ele)=>{
          exhibitSlide.insertAdjacentHTML('beforeend', ele);
          // exhibitSlide.insertAdjacentHTML('beforeend', `<div class="photo bg-black"><img src="${ele}" alt=""></div>`);
        });

        
        $('.exhibitSlide').slick({
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          // variableWidth: true,
          centerPadding: '0px',
          prevArrow: '<div class="slick-prev prev-arrow"><i class="fa-solid fa-arrow-left"></i></div>',
          nextArrow: '<div class="slick-next next-arrow"><i class="fa-solid fa-arrow-right"></i></div>',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                centerPadding: '36px',
              }
            },
          ]
        });


        const video = document.querySelectorAll('.exhibitCover .video');
        setTimeout(function(){
          video.forEach((ele)=>{
            ele.style.height = ele.getBoundingClientRect().width - 32 + 'px';
          });
        }, 800);
        
      });

    });
  }
  
  if ( document.querySelector('.eventWrap') != null ){

    const photoRowLeftLoop = document.querySelector(".photoRowLeftLoop");
    const photoRowLeftLoopList = photoRowLeftLoop.querySelectorAll(".photoRowList");
    photoRowLeftLoopList.forEach(function(el) {
      const rowLeftLooping = new TimelineMax({ repeat: -1 });
      rowLeftLooping.staggerFromTo(
        el,
        20,
        { xPercent: -100, ease: Linear.easeNone },
        { xPercent: 0, ease: Linear.easeNone }
      );
      // const Move = () => rowLeftLooping.timeScale(1);
      // const Slow = () => rowLeftLooping.timeScale(.3);
      const Move = () => rowLeftLooping.timeScale(.4);
      const Slow = () => rowLeftLooping.timeScale(.1);
      photoRowLeftLoop.addEventListener("mouseenter", Slow);
      photoRowLeftLoop.addEventListener("mouseleave", Move);
      photoRowLeftLoop.addEventListener("touchstart", Slow);
      photoRowLeftLoop.addEventListener("touchend", Move);
    });

    const photoRowRightLoop = document.querySelector(".photoRowRightLoop");
    const photoRowRightLoopList = photoRowRightLoop.querySelectorAll(".photoRowList");
    photoRowRightLoopList.forEach(function(el) {
      const rowLooping = new TimelineMax({ repeat: -1 });
      rowLooping.staggerFromTo(
        el,
        20,
        { xPercent: 100, ease: Linear.easeNone },
        { xPercent: 0, ease: Linear.easeNone }
      );
      // const Move = () => rowLooping.timeScale(1);
      // const Slow = () => rowLooping.timeScale(.3);
      const Move = () => rowLooping.timeScale(.4);
      const Slow = () => rowLooping.timeScale(.1);
      photoRowRightLoop.addEventListener("mouseenter", Slow);
      photoRowRightLoop.addEventListener("mouseleave", Move);
      photoRowRightLoop.addEventListener("touchstart", Slow);
      photoRowRightLoop.addEventListener("touchend", Move);
    });


    const eventCover = document.querySelector('.eventCover');
    const closeBtn = eventCover.querySelector('.closeBtn');

    const eventSlide = eventCover.querySelector('.eventSlide');

    closeBtn.addEventListener('click', (item)=>{
      eventCover.classList.remove('active');
      setTimeout(()=>{
        $('.eventSlide').slick('unslick');
        eventCover.querySelectorAll('.eventSlide .photo').forEach((ele)=>{
          ele.remove();
        });
      }, 1000);
    });

    
    const eventWrap = document.querySelector('.eventWrap');
    const slideItem = eventWrap.querySelectorAll('.slideItem');
  
    slideItem.forEach((item, index)=>{

      item.addEventListener('click', (ele)=>{

        setTimeout(function(){
          eventCover.classList.add('active');
        }, 300);

        var currentID = item.dataset.id;


        event_data.forEach((eventItem)=>{
          if ( currentID == eventItem.id ){
            var currentPhotos = eventItem.photos;
            
            currentPhotos.forEach((ele)=>{
              eventSlide.insertAdjacentHTML('beforeend', `<div class="px-8 photo"> <div class="rounded-lg overflow-hidden"> <img src="${ele}" alt=""> </div> </div>`);
            });

            console.log(currentPhotos);

          }
        });


        setTimeout(function(){
          $('.eventSlide').slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            // variableWidth: true,
            centerPadding: '30px',
            prevArrow: '<div class="slick-prev prev-arrow"><i class="fa-solid fa-arrow-left"></i></div>',
            nextArrow: '<div class="slick-next next-arrow"><i class="fa-solid fa-arrow-right"></i></div>',
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  centerPadding: '36px',
                }
              },
            ]
          });    
        }, 200);

      });

    });

  }

});


window.addEventListener("scroll", function() {
  contentAnimeteIn();
});


window.addEventListener("resize", function() {
  twInnerHeight();
});
